import request, { IWorkspaceResponse } from '/@/api/http/request'

const API_PREFIX = '/control/api/v1'

// 获取飞行控制权
export async function postFlightAuth (sn: string): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(`${API_PREFIX}/devices/${sn}/authority/flight`)
  return resp.data
}

export enum WaylineLostControlActionInCommandFlight {
  CONTINUE = 0,
  EXEC_LOST_ACTION = 1
}

// 手飞失联动作
export enum LostControlActionInCommandFLight {
  HOVER = 0, // 悬停
  Land = 1, // 着陆
  RETURN_HOME = 2, // 返航
}

export const LostControlActionInCommandFLightMap = {
  [LostControlActionInCommandFLight.HOVER]: '悬停',
  [LostControlActionInCommandFLight.Land]: '着陆',
  [LostControlActionInCommandFLight.RETURN_HOME]: '返航'
}

// 返航模式设置值 {"0":"智能高度","1":"设定高度"}
export enum ERthMode {
  SMART = 0,
  SETTING = 1
}

export const ERthModeMap = {
  [ERthMode.SMART]: '智能高度',
  [ERthMode.SETTING]: '设定高度'
}

// 指点飞行失控动作{"0":"继续执行指点飞行任务","1":"退出指点飞行任务，执行普通失控行为"}
export enum ECommanderModeLostAction {
  CONTINUE = 0,
  EXEC_LOST_ACTION = 1
}

export const ECommanderModeLostActionMap = {
  [ECommanderModeLostAction.CONTINUE]: '继续指点执行',
  [ECommanderModeLostAction.EXEC_LOST_ACTION]: '执行普通失控'
}

// 指点飞行模式设置值
export enum ECommanderFlightMode {
  SMART = 0,
  SETTING = 1
}

// 指点飞行模式设置值{"0":"智能高度飞行","1":"设定高度飞行"}
export const ECommanderFlightModeMap = {
  [ECommanderFlightMode.SMART]: '智能高度飞行',
  [ECommanderFlightMode.SETTING]: '设定高度飞行'
}

export interface PointBody {
  latitude: number;
  longitude: number;
  height: number;
}

export interface PostFlyToPointBody {
  max_speed: number,
  points: PointBody[]
}

// 飞向目标点
export async function postFlyToPoint (sn: string, body: PostFlyToPointBody): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(`${API_PREFIX}/devices/${sn}/jobs/fly-to-point`, body)
  return resp.data
}

// 停止飞向目标点
export async function deleteFlyToPoint (sn: string): Promise<IWorkspaceResponse<null>> {
  const resp = await request.delete(`${API_PREFIX}/devices/${sn}/jobs/fly-to-point`)
  return resp.data
}

export interface PostTakeoffToPointBody{
  target_height: number; // 目标点高度,目标点高度（椭球高），使用 WGS84 模型，飞行器到点后默认行为：悬停 {"max":1500,"min":2,"step":0.1,"unit_name":"米 / m"}
  target_latitude: number; // 目标点纬度 {"max":90,"min":-90,"step":0.000001}
  target_longitude: number; // 目标点经度 {"max":180,"min":-180,"step":0.000001}
  security_takeoff_height: number; // 安全起飞高,相对(机场)起飞点的高度（ALT），飞行器先升到特定的高度，然后再飞向目标点。
  max_speed: number; // 一键起飞的飞行过程中能达到的最大速度,flyto过程中能达到的最大速度, 单位m/s 跟飞机档位有关{"max":15,"min":1,"unit_name":"米每秒 / m/s"}
  rc_lost_action: LostControlActionInCommandFLight; // 失控行为{"0":"悬停","1":"着陆(降落)","2":"返航"}
  rth_altitude: number; // 返航高度{"max":1500,"min":2,"step":1,"unit_name":"米 / m"},相对(机场)起飞点的高度，相对高 ALT
  exit_wayline_when_rc_lost: WaylineLostControlActionInCommandFlight;
  rth_mode: ERthMode;// 返航模式设置值 {"0":"智能高度","1":"设定高度"}
  commander_mode_lost_action: ECommanderModeLostAction;// 指点飞行失控动作{"0":"继续执行指点飞行任务","1":"退出指点飞行任务，执行普通失控行为"}
  commander_flight_mode: ECommanderFlightMode;// 指点飞行模式设置值{"0":"智能高度飞行","1":"设定高度飞行"}
  commander_flight_height: number;// 指点飞行高度{"max":3000,"min":2,"step":0.1,"unit_name":"米 / m"}
  flight_safety_advance_check: boolean; // 飞行安全提前检查{"0":"关闭","1":"开启"}
  generate_report: number
  is_analysis: boolean // 是否开启视频分析{"true":"是","false":"否"}
  pilot_id: number // 飞手Id
  pilot_name: string // 飞手用户名
  portion: string
  portion_code: string
  portion_type: string
  algorithm_id: string
}

// 一键起飞
export async function postTakeoffToPoint (sn: string, body: PostTakeoffToPointBody): Promise<IWorkspaceResponse<null>> {
  const resp = await request.post(`${API_PREFIX}/devices/${sn}/jobs/takeoff-to-point`, body)
  return resp.data
}

// 查询设备正在执行的航线任务名称
export async function getWaylineName (deviceSn: string): Promise<IWorkspaceResponse<null>> {
  const resp = await request.get(`/wayline/api/v1/workspaces/jobs/${deviceSn}`)
  return resp.data
}
